import React, { useEffect } from "react";
import { retrieveLaunchParams } from "@telegram-apps/sdk";
import { useMutation, useApolloClient } from "@apollo/client";
import { SignInByTelegramMutation } from "arena/mutations";
import ErrorScreen from "core/components/ErrorScreen";
import AuthenticatingScreen from "arena/components/AuthenticatingScreen";

export default function AuthByTelegram() {
  const client = useApolloClient();

  const [signInByTelegram, { error, called }] = useMutation(
    SignInByTelegramMutation,
    {
      refetchQueries: ["Viewer", "Arena"],
      onCompleted: () => {
        console.log("signInByTelegram onCompleted");
        client.resetStore();
      },
      onError: (error) => {
        console.log("signInByTelegram onError", error);
      },
    }
  );

  useEffect(() => {
    if (called) return;

    const { initDataRaw, startParam } = retrieveLaunchParams();

    signInByTelegram({
      variables: {
        initData: initDataRaw,
        startParam,
      },
    });
  }, [called, signInByTelegram]);

  if (error) {
    return <ErrorScreen error={error} />;
  }

  return <AuthenticatingScreen />;
}
